import type {ServiceList} from "../../../types/services.types";

import {deleteService} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceKeys, serviceMutationKeys} from "../../../service-keys";

export function deleteServiceMutationOptions() {
  const listFilter = {queryKey: serviceKeys.lists()};
  return mutationOptions({
    mutationKey: serviceMutationKeys.deleteService,
    mutationFn: (id: string) => deleteService(id),
    onMutate: async (id, {client}) => {
      await client.cancelQueries(listFilter);
      const previousLists = client.getQueriesData<ServiceList>(listFilter);
      for (const [key, list] of previousLists) {
        const params = key[2];
        if (
          !list ||
          typeof params !== "object" ||
          params === null ||
          !("state" in params) ||
          params.state !== "ACTIVE" ||
          !list.items.some((item) => item.serviceId === id)
        )
          continue;
        client.setQueryData<ServiceList>(key, {
          ...list,
          items: list.items.filter((item) => item.serviceId !== id),
          meta: {...list.meta, total: Math.max(0, list.meta.total - 1)},
        });
      }
      return {previousLists};
    },
    onError: (_error, _id, context, {client}) => {
      for (const [key, snapshot] of context?.previousLists ?? [])
        client.setQueryData(key, snapshot);
    },
    onSuccess: async (_result, id, _context, {client}) => {
      client.removeQueries({queryKey: serviceKeys.detail(id)});
      await client.invalidateQueries(listFilter);
    },
  });
}
